import { Position,  Intent, Toaster } from "@blueprintjs/core";

const AppToaster = Toaster.create({
    className: "copied-content",
    position: Position.TOP,
});

const showToast = () => {
    AppToaster.show({ message: "Copied", intent: Intent.SUCCESS, timeout: 1000});
}

export const copyToClipboard = (outreach) =>{
    var textField= document.createElement('textarea')
    textField.innerHTML=outreach.ProspectContent
    document.body.appendChild(textField)
    textField.select()
    document.execCommand('copy')
    textField.remove()
    showToast()
}